import { PluginType, type IExportPlugin } from '@/version-types';
import { TextEditDependency } from './dependency';
import textEditPluginState from './states/text-edit-state';
import { TextEditPlugin } from './text-edit';
import TextEditWidget from './view/text-edit-widget';

const plugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 3,
    name: 'text-edit',
    render() {
        return <TextEditWidget />;
    },

    createInstance({ identity }) {
        return [
            { key: 'TextEditDependency', value: new TextEditDependency(identity) },
            { key: 'TextEditPlugin', value: new TextEditPlugin(identity) },
        ];
    },

    createState() {
        return [textEditPluginState];
    },
};

export default plugin;
